import React, { createContext, ReactChild } from "react";

export interface DesignServicesContextType {
  designServices?: {
    designServicesUrl: string;
    designServicesStatus: string;
    uploadAndGoUrl: string;
    uploadAndGoDescription: string;
  };
}

export const DesignServicesContext = createContext<DesignServicesContextType>({});

export interface DesignServicesContextProviderProps {
  designServices?: {
    designServicesUrl: string;
    designServicesStatus: string;
    uploadAndGoUrl: string;
    uploadAndGoDescription: string;
  };
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const DesignServicesContextProvider = (props: DesignServicesContextProviderProps) => {
  const value = {
    ...props,
  };

  return (
    <DesignServicesContext.Provider value={value}>{props.children}</DesignServicesContext.Provider>
  );
};
